export type RouteContextScope =
  | { type: 'personal' }
  | { type: 'org'; orgId: string }
  | { type: 'unknown' };

const CONTEXTUAL_ROOTS = new Set(['workspace', 'collab', 'trash', 'shared', 'ai-toolbox']);
const AI_TOOLBOX_TOOL_SEGMENTS = new Set([
  'digital-human-verification',
  'prompt-library',
  'skill-library',
]);

/**
 * Resolve whether the current URL itself is authoritative for org context.
 * Routes that need project/business data to determine context intentionally return unknown.
 */
export function resolveRouteContextScope(pathname: string): RouteContextScope {
  const [root, second] = pathname.split('/').filter(Boolean);

  if (!root) {
    return { type: 'unknown' };
  }

  if (root === 'account' || root === 'my-orgs') {
    return { type: 'personal' };
  }

  if (root === 'org' && second) {
    return { type: 'org', orgId: second };
  }

  if (!CONTEXTUAL_ROOTS.has(root)) {
    return { type: 'unknown' };
  }

  if (root === 'ai-toolbox') {
    if (!second || AI_TOOLBOX_TOOL_SEGMENTS.has(second)) {
      return { type: 'personal' };
    }
    return { type: 'org', orgId: second };
  }

  if (!second || second === 'f') {
    return { type: 'personal' };
  }

  return { type: 'org', orgId: second };
}

/** URL 明确指定空间时以 URL 为准；项目页等未知路由才回退当前标签页的组织。 */
export function resolveRequestOrgId(pathname: string, storedOrgId: string | null): string | null {
  const scope = resolveRouteContextScope(pathname);
  if (scope.type === 'org') return scope.orgId;
  if (scope.type === 'personal') return null;
  return storedOrgId;
}
